module.exports = __webpack_public_path__ + "img/collection-weddingRingsStackingRings.6b1fd5b.webp";